import React from 'react';
import PropTypes from 'prop-types';
import '../styles/main.css';
import Color from '../styles/common/Color';

const style = {
  main: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: `${Color.blurBlack}`,
    zIndex: 1500,
  },
  loadingBox: {
    minWidth: 150,
    minHeight: 150,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 5,
    padding: 10,
  },
  loadingMessages: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#000',
  },
  loading: {
    width: 50,
    height: 50,
    backgroundColor: '#fff',
    borderRadius: 5,
  },
};

const Loading = ({ loadingMessages }) => (
  <div style={style.main} className="Loading">
    <div style={style.loadingBox}>
      <div style={style.loadingMessages}>
        {loadingMessages.map((message, idx) => (
          <div key={`message${idx + 0}`}>{message}</div>
        ))}
      </div>
      <div id="circular3dG">
        <div id="circular3d_1G" className="circular3dG" />
        <div id="circular3d_2G" className="circular3dG" />
        <div id="circular3d_3G" className="circular3dG" />
        <div id="circular3d_4G" className="circular3dG" />
        <div id="circular3d_5G" className="circular3dG" />
        <div id="circular3d_6G" className="circular3dG" />
        <div id="circular3d_7G" className="circular3dG" />
        <div id="circular3d_8G" className="circular3dG" />
      </div>
    </div>
  </div>
);

Loading.propTypes = {
  loadingMessages: PropTypes.array.isRequired,
};

export default Loading;
